import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    paddingHorizontal: 30,
  },
  faqTextContainer: {
    marginHorizontal: 24,
  },
});
